var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.isVisible)?_c(_vm.tagName,{tag:"component",staticClass:"formio-component formio-component-html",domProps:{"innerHTML":_vm._s(_vm.exportMetadata.ComponentTree.content)}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }